(async () => {
  /* Update cart items */
  if (!customElements.get('related-cart-bundle')) {
    const { Fancybox } = await import('@fancyapps/ui');
    class RelatedCartBundle extends HTMLElement {

      constructor() {
        super();
        this.set = [];
        this.cartDrawer = document.querySelector('cart-drawer');
        this.button = this.querySelector('[data-total-button]');
        this.button.addEventListener('click', this.showPopup.bind(this));

      }
  
      showPopup(event){
        let otherthing = event.target.closest('related-cart-bundle').querySelector('.for-fancy')
        new Fancybox(
          [
            {
              src: otherthing.innerHTML,
              type: "html",
            },
          ],
          {
            on: {
              done: (fancybox, slide) => {
                slide.$content.querySelectorAll('[data-related-variant-id]').forEach((option) =>
                  option.addEventListener('click', (e) => {
                    let target = e.target;
                    if (!target.classList.contains('related-product--item')) {
                      target = target.closest('.related-product--item');
                    }
                    if (target.closest('[data-item-helper]').querySelector('.active')) {
                      target.closest('[data-item-helper]').querySelector('.active').classList.remove('active');
                    }
                    let activeCol = target.dataset.relatedVariantColor;
                    target.closest('[data-item-helper]').querySelector('[data-color]').innerHTML = activeCol;
                    target.classList.add('active');
                  })
                );
                slide.$content.querySelector('[data-add-button]').addEventListener('click', (e) => {
                  
                  slide.$content.querySelectorAll('.active').forEach((active) => {
                    let activeId = active.dataset.relatedVariantId;
                    this.set.push(activeId);
                  })

                  this.addToCart(fancybox, e);
                })
              },
              shouldClose: (fancybox, eventName) => {
                //console.log('qzqzqz')
              }
            },
            mainClass: 'cart-drawer-popup'
          }
        );
      }

      addToCart(fancybox, e) {
        let bundleName = e.target.dataset.bundleName;
        let bundleImg = e.target.dataset.bundleImage;
        let bundleVariantId = e.target.dataset.bundleVariantId;
        this.mainID = new Date().getTime();
        let object = {};
        let items = [];

        let theDiscount = {
          "discount":"true",
          "amount": "10",
          "type":"percent",
          "label":"BUNDLE DISCOUNT",
          "allow_subs": "false",
          "combination": "",
          "cart_totals": 0
        };

        this.set.forEach((set) => {
          object = {};
          object = {
            quantity: 1,
            id: parseInt(set),
            properties: {
              "product_bundle": 'Bundle-' + this.mainID,
              "_product_bundle_image": bundleImg,
              "_product_bundle_discount": 10,
              "_product_bundle_name": bundleName,
              "_product_bundle_variant_id": bundleVariantId,
              "_discount": theDiscount,
              "_funnel": 'cart drawer',
              "_funnel_location": 'pair_with',
              "_funnel_type": 'manual'
            }
          }
          items.push(object);
        });

        const sectionsToFetch = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ]; 
    
        let body = JSON.stringify({
          items: items,
          sections: sectionsToFetch,
          sections_url: window.location.pathname
        });
    
        fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.json())
          .then((parsedState) => {
  
            localStorage.removeItem('refused_gifts');
            this.cartDrawer.renderContents(parsedState);
            fancybox.close();
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.cartDrawer.open();
            this.set = [];
            document.querySelectorAll('.loading').forEach((loader) => {
              loader.classList.remove('loading');
            });
          });
      }
  
    }

    customElements.define('related-cart-bundle', RelatedCartBundle);
  }
})();
